export const paramsToFormData = (params) => {
    const formData = new FormData();
    Object.entries(params).forEach(param => {
        const [key, value] = param;
        formData.append(key, value);
    });
    return formData;
};
//# sourceMappingURL=paramsToFormData.js.map